import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {getBaseURL} from 'src/utils/helper';
import {
    NotificationByIdRequest,
    NotificationDTO,
    NotificationMarkAsReadRequest,
    NotificationMarkAsUnreadRequest,
    NotificationsPageDTO,
    NotificationsRequest,
    NotificationsSearchRequest,
} from '../../types';
import {NotificationStats} from 'src/types/stats';

export const notificationApi = createApi({
    reducerPath: 'notificationApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/notifications'),
    }),
    tagTypes: ['Notifications'],
    endpoints: (build) => ({
        getNotifications: build.query<NotificationsPageDTO, NotificationsSearchRequest>({
            query: ({data, params}) => ({url: '/search', method: 'post', data, params}),
            providesTags: ['Notifications'],
        }),
        // Same body as the list; the tag makes marking one read or unread recount the tiles too.
        getNotificationStats: build.query<NotificationStats, NotificationsRequest>({
            query: (data) => ({url: '/stats/summary', method: 'post', data}),
            providesTags: ['Notifications'],
        }),
        getNotificationById: build.query<NotificationDTO, NotificationByIdRequest>({
            query: (params) => ({
                url: `/${params.notificationId}`,
                method: 'get',
                params: params.data,
            }),
            providesTags: ['Notifications'],
        }),
        markNotificationAsRead: build.mutation<NotificationsPageDTO, NotificationMarkAsReadRequest>({
            query: ({notificationId, data}) => ({
                url: `/${notificationId}/read`,
                method: 'post',
                params: data,
            }),
            invalidatesTags: ['Notifications'],
        }),
        markNotificationAsUnread: build.mutation<NotificationsPageDTO, NotificationMarkAsUnreadRequest>(
            {
                query: ({notificationId, data}) => ({
                    url: `/${notificationId}/unread`,
                    method: 'post',
                    params: data,
                }),
                invalidatesTags: ['Notifications'],
            }
        ),
    }),
});
